import { useEffect, useState } from 'react';

type useIsInViewportProps = {
  elementId: string | undefined;
  options?: IntersectionObserverInit;
}

export const useIsInViewport = ({
  elementId,
  options = { threshold: 0.1, rootMargin: '0px' }
}: useIsInViewportProps): boolean => {
  const [isElementVisible, setIsElementVisible] = useState(true);

  useEffect(() => {
    if (!elementId) {
      setIsElementVisible(true);
      return;
    }

    const element = document.getElementById(elementId);
    if (!element) {
      setIsElementVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsElementVisible(entry.isIntersecting);
        });
      },
      options
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementId, options]);

  return isElementVisible;
};